/**
 * Copyright(c) 2022 Fenix Outdoor International AG.
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information of Fenix ("Confidential
 * Information"). You shall not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the contract agreement you entered into with Fenix.
 *
 */
import httpApi from "./httpApi";

/**
 *This method is used to login
 *
 * @param {*} loginData
 */

const login = async (loginData) => {
  const response = await httpApi.post("/v1/admin/login", loginData);
  return response.data;
};

/**
 * This method is used  to get list of  customers
 * */

const getCustomerList = async (companyId, customerAccount, page = 0, size, sort = "", sortDirection = "") => {
  const params = {
    companyId,
    customerAccount,
    page,
    size,
    sort,
    sortDirection,
  };
  const response = await httpApi.get("/v1/b2b/customer", { params });
  if (response && response.data) {
    return response.data;
  }

  return null;
};

/**
 * This method is used to edit customer details
 * */
const editCustomerDetails = async (id, customerData) => {
  const response = await httpApi.patch(`/v1/b2b/customer/id/${id}`, customerData);
  if (response && response.data) {
    return response.data;
  }

  return null;
};

/**
 *This method is used to change Password
 *
 * @param data
 */

const changePassword = async (data) => {
  const response = await httpApi.patch("/v1/admin/password", data);
  if (response && response.data) {
    return response.data;
  }
  return null;
};

export {
  login,
  getCustomerList,
  editCustomerDetails,
  changePassword,
};
